//Componente Carregando...
const Carregando = () => {
    return (
      <div className="Auto">
        <h1>Carregando...</h1>
      </div>
    );
  };

  export default Carregando;